<template>
  <p class="card-company__name" data-jest="company-paragraph">
    {{ name }}
  </p>
</template>

<script>
export default {
  name: 'CardSingleCompanyName',

  props: {
    name: {
      type: String,
      required: true,
    },
  },
}
</script>

<style scoped></style>
